export default function isNilUtil (value) {
  return value == null
}
